<template>
  <div>
    <Login/>
    <div class="zone-content-form wf-section" v-if="ready">
      <div class="container-content-form-suite w-container">
        <div class="w-layout-grid grid-form">
          <div class="div-precedent"></div>
          <div class="div-content-form">
            <p class="form-titre-page inscription-attestation-proprietaire">Connectez-vous à votre espace Pautions.<span class="text-span-9"></span></p>
            <div class="form-inscription-locataire w-form">
              <p class="txt-inscription-locataire">Raison sociale : {{user.raison_social}}</p>
              <p class="txt-inscription-locataire">Vous êtes : {{user.prenom}} {{user.nom}}</p>
              <p class="txt-inscription-locataire">Mail : {{user.email}}</p>
              <form name="wf-form-Mail">
                <p class="form-second-titre">Merci de créer un mot de passe pour votre compte Pautions :<span class="text-span-9"></span></p>
                <div class="div-champs-form pass">
                  <p class="texte-info-form motdepasse">Mot de passe</p>
                  <div class="div-block-11">
                    <input type="text" class="champs-formulaire pass w-input" maxlength="256" name="Mot-de-passe" data-name="Mot de passe" placeholder=""  v-model="password">
                    <img width="25" loading="lazy" :src="require('@/assets/images/ic_eye_open.svg')" alt="" class="mot-de-passe-visible"><img width="25" loading="lazy" :src="require('@/assets/images/ic_eye_open.svg')" alt="" class="mot-de-passe-non-visible">
                  </div>
                </div>
                <a v-if="loader === false" data-wait="Se connecter et signer" style="text-align:center;" class="bouton-continuer mail w-button" @click="save()">
                  sauvegarder
                </a>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Login from '@/components/Menu/Login';
export default {
  name: "InscriptionProrprietaire",
  components: {
    Login
  },
  data(){
    return {
      ready:false,
      loader:false,
      user:{},
      password:null
    }
  },
  beforeMount(){
    if(this.$route.params.uuid != undefined){
      this.$store.api.ajax('/partenaire/activation/'+this.$route.params.uuid, null, res => {
        if(res.status === true){
          this.user = res.data;
          this.ready = true;
        }
      })
    }
  },
  methods: {
    save(){
      var params = {
        uuid:this.$route.params.uuid,
        password:this.password
      }
      this.loader = true;
      this.$store.api.ajax('/partenaire/activation/update', params, res => {
        if(res.status === true){
          this.$store.api.saveToken(res.data.token);
          this.$store.api.saveUser(res.data);
          if(res.data.first === true){
            this.$router.push({path:'/partenaire/liste?first=true'});
          }else{
            this.$router.push({path:'/partenaire/liste'});
          }
        }else{
          this.loader = false;
        }
      });
    }
  },
  beforeCreate() {
    document.getElementsByTagName('body')[0].className = "body-form";
  },
}
</script>
<style scoped>
@media only screen and (max-width: 600px) {
  .w-layout-grid.grid-form {
    display: block !important;
  }
}
</style>
